module.exports = __webpack_public_path__ + "img/F1b.f649b5bd.svg";